// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"68cee2d1","6184":"68cee2d1","6852":"68cee2d1","8408":"133d0ac0","9871":"4280b005"}[chunkId] + ".chunk.css";
};